module.exports = __webpack_public_path__ + "img/section4Logo6.1156acc0.svg";